import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function RefundPolicy() {
    return (
        <LegalPage title="Refund Policy" lastUpdated="May 26, 2026">
            <p>
                At{" "}
                <a
                    href="https://www.caribbeanmealprep.net"
                    className="text-forest font-bold underline"
                >
                    Caribbean Meal Prep
                </a>
                , we take pride in preparing fresh, healthy Caribbean-inspired
                meals. Please review our refund and cancellation policy
                carefully before placing your order.
            </p>

            <h2>Order Cancellations</h2>
            <p>
                All purchases made through Caribbean Meal Prep are considered
                final.
            </p>
            <p>
                Customers may request to cancel an order within{" "}
                <strong>24 hours</strong> of purchase. Once approved, refunds
                will be issued as <strong>store credit / gift card only</strong>
                , which may be used toward future purchases on our website.
            </p>
            <p className="font-bold text-burnt">Important:</p>
            <ul>
                <li>
                    Orders placed on <strong>Saturdays</strong> are{" "}
                    <strong>non-refundable and non-cancelable</strong>.
                </li>
                <li>
                    Once meal preparation has started, orders may no longer be
                    eligible for cancellation.
                </li>
            </ul>

            <h2>Refunds</h2>
            <p>
                Refunds are not issued back to the original payment method
                unless required by law. Approved cancellations or eligible
                issues may receive:
            </p>
            <ul>
                <li>Store credit</li>
                <li>Replacement meals</li>
                <li>Partial credit at our discretion</li>
            </ul>
            <p>
                For refund or cancellation questions, please contact us through{" "}
                <a
                    href="https://www.caribbeanmealprep.net"
                    className="text-forest font-bold underline"
                >
                    www.caribbeanmealprep.net
                </a>
                .
            </p>

            <h2>Damaged or Incorrect Orders</h2>
            <p>
                Please inspect your order immediately upon delivery or pickup.
            </p>
            <p>If your order is:</p>
            <ul>
                <li>Damaged</li>
                <li>Incorrect</li>
                <li>Missing items</li>
                <li>Defective</li>
            </ul>
            <p>
                Please contact us as soon as possible so we can review the issue
                and make it right.
            </p>
            <p>Photos of the issue may be requested for verification purposes.</p>

            <h2>Non-Refundable Items</h2>
            <p>We do not accept returns or refunds for:</p>
            <ul>
                <li>Custom meal requests</li>
                <li>Personalized orders</li>
                <li>Sale or discounted items</li>
                <li>Gift cards</li>
                <li>Meals already consumed or partially consumed</li>
            </ul>

            <h2>Food Safety Notice</h2>
            <p>
                Due to the perishable nature of prepared food products, meals
                cannot be returned once delivered or picked up.
            </p>
            <p>
                Customers are responsible for properly refrigerating and storing
                meals after receiving them.
            </p>

            <h2>Pre-Orders &amp; Deposits</h2>
            <p>
                When you place a <strong>pre-order</strong> (any order with a
                delivery date 7 or more days in the future), you may choose to
                pay a deposit at checkout instead of the full amount. The
                remaining balance is due by the standard order cutoff for your
                delivery date (Thursday 10:00 PM ET for Friday delivery, Friday
                10:00 PM ET for Saturday delivery).
            </p>
            <p>
                We will email you up to two payment reminders before the balance
                deadline. <strong>If the balance is not paid by the deadline,
                the order is automatically canceled and the deposit is forfeited
                in full.</strong> Deposits on canceled-for-non-payment pre-orders
                are <strong>not refundable</strong>. This protects the time and
                ingredients reserved for your order.
            </p>
            <p>
                If you need to cancel a pre-order <em>before</em> the balance
                deadline, contact us and we will issue a full refund of the
                deposit.
            </p>

            <h2>Policy Updates</h2>
            <p>
                Caribbean Meal Prep reserves the right to update or modify this
                Refund Policy at any time without prior notice.
            </p>

            <h2>Contact Us</h2>
            <p>For refund or cancellation requests, reach out to us at:</p>
            <ul>
                <li>
                    Website:{" "}
                    <a
                        href="https://www.caribbeanmealprep.net"
                        className="text-forest font-bold underline"
                    >
                        www.caribbeanmealprep.net
                    </a>
                </li>
                <li>
                    Email:{" "}
                    <a
                        href="mailto:caribbeanmealp@gmail.com"
                        className="text-forest font-bold underline"
                    >
                        caribbeanmealp@gmail.com
                    </a>
                </li>
            </ul>
        </LegalPage>
    );
}
